// extracted by css-extract-rspack-plugin
export default {"TextPlaceholder":"assignees-renderer-module__TextPlaceholder__FBF8T"};